<template>
  <el-table
    :data="newList"
    height="300px">
    <el-table-column
      prop="idx"
      width="50">
    </el-table-column>
    <el-table-column
      prop="customerName"
      label="客户名称">
    </el-table-column>
    <el-table-column
      width="80"
      prop="averageCustomerAmount"
      :formatter="row=> row.averageCustomerAmount + '元'"
      label="平均客单价">
    </el-table-column>
    <el-table-column
      width="80"
      prop="totalAmount"
      :formatter="row=> row.totalAmount + '元'"
      label="下单金额">
    </el-table-column>
    <el-table-column
      width="80"
      prop="totalProductSoldQuantity"
      :formatter="row=> row.totalOrderCount + '单'"
      label="下单数">
    </el-table-column>
  </el-table>
</template>

<script>
export default {
  name: 'ProductTable',
  props: {
    list: {
      type: Array,
      default() {
        return []
      }
    }
  },
  computed: {
    newList() {
      return this.list.map((i, idx) => {
        return {
          ...i,
          idx: idx + 21
        }
      })
    }
  }
}
</script>

